module.exports = __webpack_public_path__ + "img/MCE_Sample_Certificate.a2b894fe.png";